export default "eee329908911deb0.png"